import { render, staticRenderFns } from "./PriceTemplateDetailDialog.vue?vue&type=template&id=0793ec8f&scoped=true"
import script from "./PriceTemplateDetailDialog.vue?vue&type=script&lang=js"
export * from "./PriceTemplateDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceTemplateDetailDialog.vue?vue&type=style&index=0&id=0793ec8f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0793ec8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0793ec8f')) {
      api.createRecord('0793ec8f', component.options)
    } else {
      api.reload('0793ec8f', component.options)
    }
    module.hot.accept("./PriceTemplateDetailDialog.vue?vue&type=template&id=0793ec8f&scoped=true", function () {
      api.rerender('0793ec8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/PriceTemplateDetailDialog.vue"
export default component.exports